import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { SwUpdate } from '@angular/service-worker';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(updates: SwUpdate, private spinner: NgxSpinnerService) {

    //reload the tab when update is available
    updates.available.subscribe(event => {
      updates.activateUpdate().then(() => document.location.reload());
    });

  }

  title = 'Nagarajan R';

  ngOnInit(): void {
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 2000);
  }

}
